<template>
  <div>
    <v-btn
      data-cy="createProjectButton"
      fab
      absolute
      bottom
      right
      dark
      v-model="fab"
      v-if="fab && $route.path === '/'"
      :color="buttonColor"
      @click="createProject"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <div v-if="displayFirstProjectDiv" class="project-tooltip" @click="createProject" > {{addFirstProjectTooltip}} </div>
    <SetProjectDialog
      v-if="openDialog"
      @close-dialog="closeDialog"
      :isActive="openDialog"
      :projectToEdit="projectToEdit"
      :editMode="editMode"
    />
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ErrorsMixin from '@/components/Mixins/ErrorsMixin.vue';
import { EventBus, EventBusEvents } from '@/helpers/event-bus';
import { ProjectMeta } from '@/classes/ProjectMeta';
import SetProjectDialog from '@/components/Projects/SetProjectDialog.vue';
import _color from '@/helpers/colors';
import { Filter } from '@/interfaces/PayloadsType';

@Component({
  components: {
    SetProjectDialog
  }
})
export default class CreateProject extends Mixins(ErrorsMixin) {
  // props
  @Prop()
  public readonly projectProp?: string;
  // attributes
  public editMode: boolean = false;
  public fab: boolean = true;
  public openDialog: boolean = false;
  private defaultProject: ProjectMeta = new ProjectMeta({
    uuid: null,
    country3Ref: null,
    country: null,
    site: null,
    name: null,
    typeRef: null,
    startDate: new Date(),
    activityStartDate: new Date(),
    gasStationCode: null,
    scenarios: null
  });
  private project = new ProjectMeta(this.defaultProject);
  // to check if it s an edit Project

  private playedOnce: boolean = false;
  private displayFirstProjectDiv: boolean = false;

  private createProject() {
    this.editMode = false;
    this.openDialog = true;
  }

  private closeDialog() {
    this.openDialog = false;
    this.project = new ProjectMeta(this.defaultProject);
  }

  get projectToEdit() {
    return this.project;
  }

  get buttonColor(): string {
    return _color.pinkButton;
  }

  get getProjectsAreLoaded(): boolean {
    return this.$store.getters['structure/getProjectsAreLoaded'];
  }
  get getProjectFilter(): Filter {
    return this.$store.getters['structure/getProjectFilter'];
  }

  get getProjects(): ProjectMeta[] {
    return this.$store.getters['structure/getProjects'];
  }

  get addFirstProjectTooltip(): string {
    return this.$t('project.first_project').toString();
  }

  get videoUrl(): string {
    return this.$t('dashboard.list.video').toString();
  }

  private mounted() {
    EventBus.$on(EventBusEvents.editProject, (project: ProjectMeta) => {
      this.openDialog = true;
      this.project = project;
      this.editMode = true;
    });
  }
  private beforeDestroy() {
    EventBus.$off(EventBusEvents.editProject);
  }

  private setDisplayFirstProject() {
    if (this.getProjects.length) {
      this.displayFirstProjectDiv = false;
    } else {
      if (this.getProjectFilter.filter) {
        this.displayFirstProjectDiv = false;
      } else {
        this.displayFirstProjectDiv = true;
      }
    }
  }

  @Watch('displayFirstProjectDiv', { immediate: true })
  private onFirstProjectChange(newVal: boolean) {
    if (this.displayFirstProjectDiv) {
      EventBus.$emit(EventBusEvents.playVideo, this.videoUrl, false);
    }
  }

  @Watch('getProjects', { immediate: true })
  private onGetProjects() {
    /**
     * @getProjectsAreLoaded to avoid getting the initial getProjectsAreLoaded
     */
    if (this.getProjectsAreLoaded) {
      this.setDisplayFirstProject();
    }
  }

  @Watch('videoUrl', { immediate: true })
  private onVideoUrl(newVal: string, oldVal: string) {
    if (newVal !== oldVal && this.displayFirstProjectDiv) {
      EventBus.$emit(EventBusEvents.playVideo, this.videoUrl, false);
    }
  }
}
</script>

<style lang="stylus">
.project-tooltip {
  text-align: center;
  position: absolute;
  color: #FFF;
  top: 100px;
  right: 90px;
  padding: 10px;
  width : auto;
  height : auto;
  background: #EC5785AA;
  animation: blinker 1.5s linear infinite;
  border: 2px solid #FFF
  cursor: pointer;
}
@keyframes blinker {
  50% { background-color : #bc1a4b; }
  50% { opacity : 0.5}
}
.close-btn {
  position: absolute;
  right: 5px;

  .close-icn {
    color: red;
  }
}
</style>
